// Site-wide configuration (placeholder values — edit later)
export const SITE = {
  brand: "Persia Persianas y Cortinas",
  brandShort: "Persia",
  tagline: "Persianas y Cortinas en Guadalajara y Zona Metropolitana",
  phoneDisplay: "+52 33 3462 7333",
  whatsappNumber: "523334627333", // E.164 sin '+' para wa.me
  email: "persianasycortinaspersia@gmail.com",
  zone: "Guadalajara y Zona Metropolitana",
  hours: [
    { label: "Lunes a Viernes", value: "9:00 – 18:00" },
    { label: "Sábado", value: "10:00 – 15:00" },
    { label: "Domingo", value: "Cerrado" },
  ],
  social: {
    instagram: "https://instagram.com/",
    facebook: "https://facebook.com/",
    tiktok: "https://tiktok.com/",
  },
};

export const waLink = (msg) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(msg)}`;
